import React, { useState, useEffect } from "react";
import SummaryImage from "../SummaryImage/SummaryImage";
import "./ProductCard.scss";
import { Link, useNavigate } from "react-router-dom";
import Moment from "moment-timezone";
import { useSelector, useDispatch } from "react-redux";
import translate from "../../../i18n/translate";
import Button from "@material-ui/core/Button";
import {
  activeStatus,
  dynamicCardProducts,
  soloProducts,
  sprintBusinessProducts,
  productList,
} from "../../../globalConstants";
import { useIntl } from "react-intl";
import ProductTemplate from "./ProductTemplate";
import ProductButton from "./ProductButton";
import allActions from "../../../redux/actions";
import { ProductImage } from "./ImageCard";

const ProductCard = (props: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const allInfo = useSelector((state: any) => state);
  const intl = useIntl();
  let activeCourseStatus = activeStatus || [{}];
  const [scheduleCourseID, setScheduleCourseID] = useState("");
  const [elevateInfo, setelevateInfo] = useState({
    courseStatus: "",
    sessionsCompleted: "",
    courseLevel: "",
    upcomingSession: "",
  });
  const [redirectPath, setredirectPath] = useState<string | undefined>(undefined);
  const { stepAuthorizationData } = useSelector((state: any) => state.progressDetails);

  const timeOnSightUpdateOnRedirect = () => {
    const uId: any = sessionStorage.getItem("leuId")?.toString()
    if(props.redirectURL.startsWith("https://")) dispatch(allActions.tosSessionInfoAction.getTosSessionInfo(uId, "6"));
  }

  const redirectToProduct = async (e: any) => {
    e.preventDefault();
    handleWelcomeFlowUpdate();
    if (props.redirectURL)  handleRedirect();
    return;
  };
  
  const handleWelcomeFlowUpdate = () => {
    const uId = allInfo.peopleInformation.data.getpeopleInformation.edgeUid;
    if(!allInfo.welcomeFlowApi.data){
      setCookieForSimplified();
      dispatch(allActions.welcomeFlowRegUpdateAction.welcomeFlowRegUpdate(uId));
    }
  }
  
  const setCookieForSimplified = () => {
    let cookieNameForSimplified = "cameFrom";
    let cookieValueForSimplified = "lsm";
    let domain = JSON.parse(process.env.REACT_APP_COOKIE_DOMAINS || "[]") || [];
    let finalCookie = `${cookieNameForSimplified}=${cookieValueForSimplified};domain=${domain[0]};secure;httponly`;
    document.cookie = finalCookie;
  }
  
  const handleRedirect = () => {
    if(props.productId==="5"||props.productId==="6"){
      if (stepAuthorizationData?.testState === "Completed"){
        return navigate(`/progress/${props.productId}`)
      }
    }
    timeOnSightUpdateOnRedirect();
    handleProductCardClass();
  }
  
  const handleProductCardClass = () => {
    if (props.productcardclass === "recommended-card") {
      navigate(`${props.redirectURL}`);
    } else if ((props.productId === "13" && !sessionStorage.getItem("isDemoUser")) || props.productId === "15") {
      window.open(props.redirectURL, "_blank");
    } else if (!(elevateInfo.courseStatus === "" && props.productId === "25")) {
      window.open(props.redirectURL, "_self");
    }
  }

  const rightClickRedirection = () => {
    setredirectPath(props.redirectURL);
  };

  const redirect_schedule_url = (e: any) => {
    e.stopPropagation();
    navigate({ pathname: "/schedule/" + scheduleCourseID });
  };

  useEffect(() => {
    if (sessionStorage.getItem("isDemoUser")) {
      setelevateInfo({ ...elevateInfo, courseStatus: "0" });
    }
  }, []);

  useEffect(() => {
    if (
      allInfo.getLearnerDetails.data &&
      allInfo.createSessionService.data &&
      allInfo.tmsLearnerSessions.data &&
      allInfo.getOtherTasks.data
    ) {
      let soloUpdate = { ...elevateInfo };
      soloUpdate.courseStatus = "0";
      setelevateInfo(soloUpdate);
      if (
        allInfo.getOtherTasks.data.getLearnerTasks &&
        allInfo.getOtherTasks.data.getLearnerTasks.filter(
          (tasks: { status: boolean; taskid: String }) =>
            !tasks.status && (tasks.taskid === "2" || tasks.taskid === "3" || tasks.taskid === "4")
        ).length <= 0
      ) {
        soloUpdate.courseStatus = "1";
        soloUpdate.courseLevel =
          allInfo.getLearnerDetails.data.getLearnerInfo && allInfo.getLearnerDetails.data.getLearnerInfo.CourseLevel
            ? allInfo.getLearnerDetails.data.getLearnerInfo.CourseLevel
            : "";
        let stats = allInfo.createSessionService.data.createSessionService;
        if(stats.statistics){
            soloUpdate.sessionsCompleted =
            String(
              Number(stats.statistics.finishedSessions) +
                Number(stats.statistics.lostSessions) +
                Number(stats.statistics.upcomingSessions)
            ) +
            "/" +
            stats.length;
          if (
            Number(stats.statistics.finishedSessions) +
              Number(stats.statistics.lostSessions) +
              Number(stats.statistics.upcomingSessions) ===
            0
          ) {
            soloUpdate.courseStatus = "1";
            soloUpdate.upcomingSession = "Not scheduled";
          } else {
            soloUpdate.courseStatus = "2";
            if (!stats.statistics.upcomingSessions) {
              soloUpdate.upcomingSession = stats.statistics.upcomingSessions;
            } else {
              let upcomingData = allInfo.tmsLearnerSessions.data.getTMSLearnerSessions.filter(
                (data: { status: string }) => data.status === "upcoming"
              );
              if (upcomingData) {
                upcomingData = upcomingData
                  .slice()
                  .sort((a: any, b: any) => b.startTime - a.startTime)
                  .reverse();
                upcomingData = upcomingData[0]?.startTime;
              }
              const momentDate = Moment(Moment.unix(parseInt(upcomingData)));
              soloUpdate.upcomingSession =
                momentDate.format("DD MMM YYYY") +
                "|" +
                Moment.unix(parseInt(upcomingData)).format("hh:mm A") +
                " " +
                momentDate.tz(Moment.tz.guess()).format("z");
            }
          }
          if (
            Number(stats.statistics.finishedSessions) + Number(stats.statistics.lostSessions) ===
            Number(stats.length)
          ) {
            soloUpdate.courseStatus = "3";
          }
        }
      }
    }
  }, [allInfo.getLearnerDetails, allInfo.createSessionService, allInfo.getOtherTasks, allInfo.tmsLearnerSessions]);

  useEffect(() => {
    if (!allInfo.tmsCourses.isLoading) {
      if (
        !allInfo.tmsCourses.isFailed &&
        allInfo.tmsCourses.data &&
        allInfo.tmsCourses.data.getTMSGetCourse.length > 0
      ) {
        let activeCourseId;
        if (allInfo.tmsCourses.data.getTMSGetCourse.length > 0) {
          activeCourseId = allInfo.tmsCourses.data.getTMSGetCourse.filter(
            (course: { status: string }) => course.status == "1" || course.status == "2" || course.status == "3"
          );
          activeCourseId =
            activeCourseId.length > 0
              ? allInfo.tmsCourses.data.getTMSGetCourse[allInfo.tmsCourses.data.getTMSGetCourse.length - 1].courseId
              : "0";
        } else {
          activeCourseId = "0";
        }
        setScheduleCourseID(allInfo.tmsCourses.data.getTMSGetCourse[0].courseId);
      }
    }
  }, [allInfo.tmsCourses]);

  const displayProductTitle = () => {
    if(props.productId != "5" && props.productId && "6" && props.productId != "15"){
      let productDetails = productList.find((x) => x.productId === props.productId);
      if (productDetails) {
        let productName = productDetails.productName;
        return (
          <div className="pCardTitle">
            {productName.substr(0, productName.indexOf(" "))} <br />{" "}
            {productName.substr(productName.indexOf(" ")).length === 1
              ? ""
              : productName.substr(productName.indexOf(" "))}
          </div>
        );
      }
    }
  };


  return (
    <a
      href={redirectPath}
      data-testid="demo-product-card"
      className={`ProductCardBlock ${props.productcardclass}`}
      onClick={redirectToProduct}
      onContextMenu={rightClickRedirection}
    >
      <div className="card_verticalContent">
        <div className="pCardBody">
          <div className="mobile-illustrations">
         <ProductImage   productId={  props.productId} title={props.title} prodcardimage={props.prodcardimage} />
            <div className="recommend-img">
              <SummaryImage alt={props.title || ""} url={props.cardimage}></SummaryImage>
            </div>
          </div>
          {!dynamicCardProducts.includes(props.productId) &&
            props.productId !== "13" &&
            props.productId !== "17" &&
            props.productId !== "25" &&
            props.productId !== "1" &&
            props.productId !== "16" &&
            props.productId !== "29" && <div className="pCardTitle">{props.title}</div>}
          {displayProductTitle()}
          {(!dynamicCardProducts.includes(props.productId) ||
            sessionStorage.getItem("isDemoUser") ||
            ((!allInfo.currentSoloCourseDetails.data || allInfo.currentSoloCourseDetails.isFailed) &&
              soloProducts.includes(props.productId)) ||
            ((!allInfo.currentCourseDetails.data || allInfo.currentCourseDetails.isFailed) &&
              (props.productId === "18" || sprintBusinessProducts.includes(props.productId)))) &&
            props.summary && (
              <div className="pCardSummary">
                <p>{props.summary}</p>
              </div>
            )}
          {elevateInfo.courseStatus === "" && props.productId === "25" && (
            <div className="parent-active-course">
              <div className="failed-active-course">
                <p>{translate("message_errorDefault")}</p>
                <p>{translate("error_clear_cache")}</p>
              </div>
            </div>
          )}
          {(((sprintBusinessProducts.includes(props.productId) || props.productId === "18") &&
            !allInfo.currentCourseDetails.isLoading &&
            allInfo.currentCourseDetails.data) ||
            (props.productId === "25" && elevateInfo.courseStatus !== "") ||
            (allInfo.currentSoloCourseDetails.data && soloProducts.includes(props.productId))) &&
            !sessionStorage.getItem("isDemoUser") &&
            props.productId && (
              <div>
                {((soloProducts.includes(props.productId) &&
                  allInfo.currentSoloCourseDetails.data.CourseStatus === "1") ||
                  ((sprintBusinessProducts.includes(props.productId) || props.productId === "18") &&
                    allInfo.currentCourseDetails.data.CourseStatus === "1")) && (
                  <ProductTemplate
                    courseDetails={
                      soloProducts.includes(props.productId)
                        ? allInfo.currentSoloCourseDetails.data
                        : allInfo.currentCourseDetails.data
                    }
                    activeCourseStatus={activeCourseStatus}
                    subSkill={
                      soloProducts.includes(props.productId)
                        ? allInfo.currentSoloCourseDetails.data.NotStarted.SkillName
                        : allInfo.currentCourseDetails.data.NotStarted.SkillName
                    }
                    subSkillTitle={
                      props.productId === "18" ? allInfo.currentCourseDetails.data.NotStarted.SubSkillTitle : ""
                    }
                    upComingSession={soloProducts.includes(props.productId) ? false : true}
                    redirectLink={
                      sprintBusinessProducts.includes(props.productId) || props.productId === "18"
                        ? redirect_schedule_url
                        : ""
                    }
                  />
                )}

                {((soloProducts.includes(props.productId) &&
                  allInfo.currentSoloCourseDetails.data.CourseStatus === "2") ||
                  ((sprintBusinessProducts.includes(props.productId) || props.productId === "18") &&
                    allInfo.currentCourseDetails.data.CourseStatus === "2")) && (
                  <ProductTemplate
                    courseDetails={
                      soloProducts.includes(props.productId)
                        ? allInfo.currentSoloCourseDetails.data
                        : allInfo.currentCourseDetails.data
                    }
                    activeCourseStatus={activeCourseStatus}
                    subSkill={
                      soloProducts.includes(props.productId)
                        ? allInfo.currentSoloCourseDetails.data.InProgress.SkillName || ""
                        : ""
                    }
                    subSkillTitle={
                      props.productId === "18" || sprintBusinessProducts.includes(props.productId)
                        ? allInfo.currentCourseDetails.data.InProgress.SubSkillTitle
                        : ""
                    }
                    upComingSession={soloProducts.includes(props.productId) ? false : true}
                    redirectLink={sprintBusinessProducts.includes(props.productId) ? redirect_schedule_url : ""}
                    sprint={sprintBusinessProducts.includes(props.productId) || props.productId == "18" ? true : false}
                  />
                )}
                {props.productId === "25" && elevateInfo.courseStatus === "2" && (
                  <div className="parent-active-course">
                    <div className="active-course">
                      <div className="active-course-current-level">
                        <b>{translate("courselevel")}</b>
                        <label className="active-course-label">{elevateInfo.courseLevel || ""}</label>
                      </div>
                      <div className="active-course-status">
                        <b>{translate("SessionRating_status")}</b>
                        <label className="active-course-lbl">{"In progress"}</label>
                      </div>
                    </div>
                    <div className="active-course-block">
                      <div className="active-course-current-level">
                        <b>{translate("category")}</b>
                        <label className="active-course-label-subskill">{"Comprehensive"}</label>
                      </div>

                      {elevateInfo.upcomingSession ? (
                        <div className="active-course-session">
                          <b>{translate("upcomingsession")}</b>
                          <label className="active-course-label-session">{elevateInfo.upcomingSession}</label>
                        </div>
                      ) : (
                        <div className="active-course-session">
                          <b>{translate("upcomingsession")}</b>
                          {elevateInfo.sessionsCompleted === "Not scheduled" ? (
                            <label className="active-course-label">{"Not scheduled"}</label>
                          ) : (
                            <a className="active-course-schedule-label"  onKeyDown={() => {}} onClick={(e: any) => redirect_schedule_url(e)}>
                              {translate("viewschedule")}
                            </a>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {((soloProducts.includes(props.productId) &&
                  allInfo.currentSoloCourseDetails.data.CourseStatus === "3") ||
                  ((sprintBusinessProducts.includes(props.productId) || props.productId === "18") &&
                    allInfo.currentCourseDetails.data.CourseStatus === "3")) && (
                  <ProductTemplate
                    courseDetails={
                      soloProducts.includes(props.productId)
                        ? allInfo.currentSoloCourseDetails.data
                        : allInfo.currentCourseDetails.data
                    }
                    activeCourseStatus={activeCourseStatus}
                    upComingSession={sprintBusinessProducts.includes(props.productId) ? true : false}
                  />
                )}
                {props.productId === "25" && elevateInfo.courseStatus === "3" && (
                  <div className="parent-active-course">
                    <div className="active-course">
                      <div className="active-course-current-level">
                        <b>{translate("courselevel")}</b>
                        <label className="active-course-label">{elevateInfo.courseLevel || ""}</label>
                      </div>
                      <div className="active-course-status">
                        <b>{translate("SessionRating_status")}</b>
                        <label className="active-course-lbl">{"Completed"}</label>
                      </div>
                    </div>
                  </div>
                )}
                {((soloProducts.includes(props.productId) &&
                  allInfo.currentSoloCourseDetails.data.CourseStatus === "0") ||
                  ((sprintBusinessProducts.includes(props.productId) || props.productId === "18") &&
                    allInfo.currentCourseDetails.data.CourseStatus === "0") ||
                  (props.productId === "25" && elevateInfo.courseStatus === "0")) && (
                  <div>
                    {props.summary && (
                      <div className="pCardSummary">
                        <p>{props.summary}</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          {((sessionStorage.getItem("isDemoUser") &&
            (props.productId == "18" ||
              props.productId == "20" ||
              props.productId == "26" ||
              props.productId == "27" ||
              props.productId == "28")) ||
            !dynamicCardProducts.includes(props.productId) ||
            ((!allInfo.currentSoloCourseDetails.data || allInfo.currentSoloCourseDetails.isFailed) &&
              (props.productId === "21" ||
                props.productId === "22" ||
                props.productId === "23" ||
                props.productId === "24")) ||
            ((!allInfo.currentCourseDetails.data || allInfo.currentCourseDetails.isFailed) &&
              (props.productId === "18" ||
                props.productId === "20" ||
                props.productId === "26" ||
                props.productId === "27" ||
                props.productId === "28"))) && (
            <span>
              {(props.roundButtonText || props.flatButtonText) && (
                <div className="pCardButtonsBlock">
                  {
                  props.title?.props ? (
                    <>
                      {" "}
                      {props.flatButtonText && (
                        <Button
                          aria-label={`${intl.formatMessage({ id: props.title.props.id })}`}
                          color="primary"
                          variant="contained"
                          size="medium"
                          className="pCardButton pCardFlatButton"
                          id={`${props.flatButtonText.props.id}`}
                        >
                          {props.flatButtonText}
                        </Button>
                      )}
                    </>
                  ) : (
                    <>
                      {props.flatButtonText && props.productId === '15'?(
                       <Button
                      //  color="primary"
                       aria-label={`${props.title}`}
                       variant="contained"
                       size="medium"
                       className="pCardButton reachButton "
                       id={`${props.flatButtonText.props.id}`}
                     >
                       {props.flatButtonText}
                     </Button>
                      )
                     : props.flatButtonText && (
                        <Button
                          color="primary"
                          aria-label={`${props.title}`}
                          variant="contained"
                          size="medium"
                          className="pCardButton pCardFlatButton"
                          id={`${props.flatButtonText.props.id}`}
                        >
                          {props.flatButtonText}
                        </Button>
                      )}
                    </>
                  )}
                </div>
              )}
            </span>
          )}
          {!allInfo.currentSoloCourseDetails.isLoading &&
            !allInfo.currentSoloCourseDetails.isFailed &&
            allInfo.currentSoloCourseDetails.data &&
            soloProducts.includes(props.productId) &&
            allInfo.currentSoloCourseDetails.data.CourseStatus === "0" && (
              <span>
                {(props.roundButtonText || props.flatButtonText) && (
                  <ProductButton title={props.title} buttonText={props.flatButtonText} />
                )}
              </span>
            )}
          {!allInfo.currentCourseDetails.isLoading &&
            allInfo.currentCourseDetails.data &&
            sprintBusinessProducts.includes(props.productId) &&
            allInfo.currentCourseDetails.data.CourseStatus === "0" && (
              <span>
                {(props.roundButtonText || props.flatButtonText) && (
                  <ProductButton title={props.title} buttonText={props.flatButtonText} />
                )}
              </span>
            )}
          {!allInfo.currentCourseDetails.isLoading &&
            allInfo.currentCourseDetails.data &&
            props.productId === "18" &&
            allInfo.currentCourseDetails.data.CourseStatus === "0" && (
              <span>
                {(props.roundButtonText || props.flatButtonText) && (
                  <ProductButton title={props.title} buttonText={props.flatButtonText} />
                )}
              </span>
            )}

          {!allInfo.currentCourseDetails.isLoading &&
            allInfo.currentCourseDetails.data &&
            sprintBusinessProducts.includes(props.productId) &&
            allInfo.currentCourseDetails.data.CourseStatus === "2" && (
              <span>
                {props.activeCourseButtonText && (
                  <ProductButton title={props.title} buttonText={props.activeCourseButtonText} />
                )}
              </span>
            )}
          {!allInfo.currentSoloCourseDetails.isLoading &&
            allInfo.currentSoloCourseDetails.data &&
            soloProducts.includes(props.productId) &&
            allInfo.currentSoloCourseDetails.data.CourseStatus === "2" && (
              <span>
                {props.activeCourseButtonText && (
                  <ProductButton title={props.title} buttonText={props.activeCourseButtonText} />
                )}
              </span>
            )}
          {!allInfo.currentCourseDetails.isLoading &&
            allInfo.currentCourseDetails.data &&
            props.productId === "18" &&
            allInfo.currentCourseDetails.data.CourseStatus === "2" && (
              <span>
                {props.activeCourseButtonText && (
                  <ProductButton title={props.title} buttonText={props.activeCourseButtonText} />
                )}
              </span>
            )}
          {!allInfo.currentCourseDetails.isLoading &&
            allInfo.currentCourseDetails.data &&
            sprintBusinessProducts.includes(props.productId) &&
            allInfo.currentCourseDetails.data.CourseStatus === "3" && (
              <span>
                {props.activeCourseCertificateButtonText && !sessionStorage.getItem("isDemoUser") && (
                  <ProductButton
                    title={props.title}
                    buttonText={props.activeCourseCertificateButtonText}
                    isDemoUser={true}
                    productId={props.productId}
                  />
                )}
              </span>
            )}
          {!allInfo.currentSoloCourseDetails.isLoading &&
            allInfo.currentSoloCourseDetails.data &&
            soloProducts.includes(props.productId) &&
            allInfo.currentSoloCourseDetails.data.CourseStatus === "3" && (
              <span>
                {props.activeCourseCertificateButtonText && !sessionStorage.getItem("isDemoUser") && (
                  <ProductButton
                    title={props.title}
                    buttonText={props.activeCourseCertificateButtonText}
                    isDemoUser={true}
                    productId={props.productId}
                  />
                )}
              </span>
            )}
          {!allInfo.currentCourseDetails.isLoading &&
            allInfo.currentCourseDetails.data &&
            props.productId === "18" &&
            allInfo.currentCourseDetails.data.CourseStatus === "3" && (
              <span>
                {props.activeCourseCertificateButtonText && !sessionStorage.getItem("isDemoUser") && (
                  <ProductButton
                    title={props.title}
                    buttonText={props.activeCourseCertificateButtonText}
                    isDemoUser={true}
                    productId={props.productId}
                  />
                )}
              </span>
            )}
          {props.productId === "25" && elevateInfo.courseStatus === "3" && (
            <span>
              {props.activeCourseCertificateButtonText && !sessionStorage.getItem("isDemoUser") && (
                <div className="pCardButtonsBlock">
                  {props.activeCourseCertificateButtonText && (
                    <Button
                      aria-label={`${props.title}`}
                      component={Link}
                      to={`/progress/${props.productId || ""}`}
                      onClick={(e: any) => e.stopPropagation()}
                      color="primary"
                      variant="contained"
                      size="medium"
                      className="pCardButton pCardFlatButton"
                      id={`${props.activeCourseCertificateButtonText.props.id}`}
                    >
                      {props.activeCourseCertificateButtonText}
                    </Button>
                  )}
                </div>
              )}
            </span>
          )}
          {!allInfo.currentCourseDetails.isLoading &&
            allInfo.currentCourseDetails.data &&
            sprintBusinessProducts.includes(props.productId) &&
            allInfo.currentCourseDetails.data.CourseStatus === "1" && (
              <span>
                {props.activeCourseContinueStudyingButtonText && (
                  <ProductButton title={props.title} buttonText={props.activeCourseButtonText} />
                )}
              </span>
            )}
          {/* added for elevate */}
          {props.productId === "25" && elevateInfo.courseStatus === "1" && (
            <div className="parent-active-course">
              <div className="active-course">
                <div className="active-course-current-level">
                  <b>{translate("courselevel")}</b>
                  <label className="active-course-label">{elevateInfo.courseLevel || ""}</label>
                </div>
                <div className="active-course-status">
                  <b>{translate("SessionRating_status")}</b>
                  <label className="active-course-lbl">{"Not Started"}</label>
                </div>
              </div>
              <div className="active-course-block">
                <div className="active-course-current-level">
                  <b>{translate("category")}</b>
                  <label className="active-course-label-subskill">{"Comprehensive"}</label>
                </div>

                {elevateInfo.upcomingSession !== "" &&
                elevateInfo.upcomingSession !== "0" &&
                elevateInfo.upcomingSession !== "Not Scheduled" ? (
                  <div className="active-course-session">
                    <b>{translate("upcomingsession")}</b>
                    <label className="active-course-label-session">{elevateInfo.upcomingSession}</label>
                  </div>
                ) : (
                  <div className="active-course-session">
                    <b>{translate("upcomingsession")}</b>
                    {
                      <a className="active-course-schedule-label" onKeyDown={() => {}} onClick={(e: any) => redirect_schedule_url(e)}>
                        {translate("viewschedule")}
                      </a>
                    }
                  </div>
                )}
              </div>
            </div>
          )}
          {props.productId === "25" && elevateInfo.courseStatus === "1" && (
            <span>
              {props.activeCourseContinueStudyingButtonText && (
                <div className="pCardButtonsBlock">
                  {props.activeCourseButtonText && (
                    <Button
                      aria-label={`${props.title}`}
                      color="primary"
                      variant="contained"
                      size="medium"
                      className="pCardButton pCardFlatButton"
                      id={`${props.activeCourseButtonText.props.id}`}
                    >
                      {props.activeCourseButtonText}
                    </Button>
                  )}
                </div>
              )}
            </span>
          )}
          {props.productId === "25" && elevateInfo.courseStatus === "0" && (
            <span>
              {(props.roundButtonText || props.flatButtonText) && (
                <div className="pCardButtonsBlock">
                  {props.flatButtonText && (
                    <Button
                      aria-label={`${props.title}`}
                      color="primary"
                      variant="contained"
                      size="medium"
                      className="pCardButton pCardFlatButton"
                      id={`${props.flatButtonText.props.id}`}
                    >
                      {props.flatButtonText}
                    </Button>
                  )}
                </div>
              )}
            </span>
          )}
          {props.productId === "25" && elevateInfo.courseStatus === "2" && (
            <span>
              {props.activeCourseButtonText && (
                <div className="pCardButtonsBlock">
                  {props.activeCourseButtonText && (
                    <Button
                      aria-label={`${props.title}`}
                      color="primary"
                      variant="contained"
                      size="medium"
                      className="pCardButton pCardFlatButton"
                      id={`${props.activeCourseButtonText.props.id}`}
                    >
                      {props.activeCourseButtonText}
                    </Button>
                  )}
                </div>
              )}
            </span>
          )}
          {!allInfo.currentSoloCourseDetails.isLoading &&
            allInfo.currentSoloCourseDetails.data &&
            soloProducts.includes(props.productId) &&
            allInfo.currentSoloCourseDetails.data.CourseStatus === "1" && (
              <span>
                {props.activeCourseContinueStudyingButtonText && (
                  <ProductButton title={props.title} buttonText={props.activeCourseButtonText} />
                )}
              </span>
            )}
          {!allInfo.currentCourseDetails.isLoading &&
            allInfo.currentCourseDetails.data &&
            props.productId === "18" &&
            allInfo.currentCourseDetails.data.CourseStatus === "1" && (
              <span>
                {props.activeCourseContinueStudyingButtonText && (
                  <ProductButton title={props.title} buttonText={props.activeCourseButtonText} />
                )}
              </span>
            )}
        </div>
      </div>
      <div className="desktop-illustrations">
      <ProductImage  productId={  props.productId} title={props.title} prodcardimage={props.prodcardimage}/>
        <div className="recommend-img">
          <SummaryImage alt={props.title || ""} url={props.cardimage}></SummaryImage>
        </div>
      </div>
    </a>
  );
};

export default ProductCard;